import React from 'react'

import PageLayout from '@/CandidateExperience/components/PageLayout'
import SubNav from '@/Applications/components/SubNav'
import ApplicationList from '@/Applications/components/ApplicationList'

import styles from './styles'

const ApplicationListScene = () => {
  return (
    <PageLayout
      toolbarContent={<SubNav />}
      body={
        <div className={styles.body}>
          <ApplicationList />
        </div>
      }
    />
  )
}

export default ApplicationListScene
